import { isNilOrEmpty } from 'ramdasauce'

export function isStudyArchived(workflow) { // eslint-disable-line import/prefer-default-export
  return workflow === 3
}

export function canStudyHaveVirtualVisits(study) {
  return !isNilOrEmpty(study) && !!study.virtualVisitConfigurationEnabled
}
